import { IUsageType } from "../interface/IUsageType";

interface IUsageTypeContentResponse {
    usageType: string;
    usageTypeName: string;
}

export interface IUsageTypeResponse {
    usageTypes: IUsageTypeContentResponse[];
}

export const getResponseToState = (response: IUsageTypeResponse): IUsageType[] =>
    response.usageTypes.map((usageType) => ({
        type: usageType.usageType,
        typeName: usageType.usageTypeName,
    }));
